export const data = {
  contactEmail: 'wemsical.serbia@gmail.com',
  artists: {
    artists: {
      HU: 'Fellépők',
      EN: 'Artists',
      RS: 'Izvođači',
    },
    follow: {
      HU: 'Kövess minket',
      EN: 'Follow us',
      RS: 'Prati nas',
    },
  },
  homepage: {
    details: {
      location: {
        HU: 'OROM, SZERBIA',
        RS: 'OROM, SRBIJA',
        EN: 'OROM, SERBIA',
      },
      date: {
        HU: '2024.08.08-10.',
        RS: '08-10.08.2024',
        EN: '08-10.08.2024',
      },
    },
    numbers: {
      days: {
        HU: 'NAP',
        RS: 'DANA',
        EN: 'DAYS',
      },
      stages: {
        HU: 'SZÍNPAD',
        RS: 'BINA',
        EN: 'STAGES',
      },
      artists: {
        HU: 'FELLÉPŐ',
        RS: 'IZVOĐAČA',
        EN: 'ARTISTS',

      },
    },
    about_desc: {
      RS: 'Jedan od glavnih ciljeva ovogodišnjeg Malomfesztivála je da sruši sve granice – unutrašnje, međuljudske i one između zemalja. Pored toga, festival ima za cilj da prikaže netaknutu lepotu Srbije, Vojvodine/Vajdaság/Voivodina/ Войводина, gde vreme kao da stoji i sat otkucava sporije. Pozivamo vas da se prepustite pustari, gde beskonačni horizont spaja nebo i zemlju, i možda ćemo naći jedno drugo u podnožju vetrenjače i zajedno postati tačka u beskonačnosti.',
      HU: 'A Malomfesztivál egyik fő célja idén is, hogy eltörölje a határokat – az összeset: a belsőket, az egymás és az országok közöttit. Emellett természetesen szeretné megmutatni Szerbia, a Vajdaság érintetlen szépségét, állapotát, ahol még egy kicsit áll az idő, lassabban ketyeg az óra, s hogy az embereket kicsalogassa a pusztába, ahol a végtelen horizontban ég és föld egybeér, s egy pont a végtelenben talán te és mi leszünk, valahol a malom tövében.',
      EN: 'One of the main goals of this year\'s Malomfesztivál  is to break down all the boundaries—internal, interpersonal and those between countries. Additionally, the festival aims to showcase the untouched beauty of Serbia, Vajdaság/Vojvodina/Voivodina/ Войводина,where time seems to stand still and the clock ticks more slowly. We invite you to venture out into the prairie, where the endless horizon sees sky and earth merging, and perhaps we will find each other at the foot of the windmill and become a point in infinity.',
    },
    about: {
      HU: 'A MALOMFESZTIVÁLRÓL',
      EN: 'ABOUT MALOMFESZTIVÁL',
      RS: 'O MALOMFESZTIVÁLU',
    },
    participate: {
      title: {
        HU: 'Része lennél a közösségnek?',
        EN: 'You would like to join the community?',
        RS: 'Želiš da postaneš deo zajednice?',
      },
      participate: {
        HU: 'Jelentkezz önkéntesnek!',
        EN: 'Apply to volunteer!',
        RS: 'Prijavi se da budeš volonter!',
      },
    },
    all: {
      HU: 'ÖSSZES',
      EN: 'ALL',
      RS: 'SVE',
    },
  },
  contact: {
    send: {
      HU: 'Küldés',
      EN: 'Send',
      RS: 'Pošalji',
    },
    write: {
      HU: 'Írj nekünk!',
      EN: 'Contact us!',
      RS: 'Piši nam!',
    },
    name: {
      HU: 'Név',
      EN: 'Name',
      RS: 'Ime',
    },
    message: {
      HU: 'Üzenet',
      EN: 'Message',
      RS: 'Poruka',
    },
    question: {
      HU: 'Kérdésed van?',
      EN: 'You have questions?',
      RS: 'Imaš pitanja?',
    },
  },
  volunteer: {
    volunteerLink: 'https://docs.google.com/forms/d/e/1FAIpQLSd6VBgR3AVBfu9yyEr5im68f7PPxkj7E3NHSGy7Qm8UIi_F7Q/viewform',
    buildingLink: 'https://docs.google.com/forms/d/e/1FAIpQLSe_MefTOxgD1P5hkV1BWB2wXwdCquxidIpAz200T5ZM1S9GfQ/viewform',
    camp: {
      HU: '(SZ)ÉPÍTŐ TÁBOR',
      EN: 'BULDING CAMP',
      RS: 'Građevinski kamp',
    },
    festival: {
      HU: 'FESZTIVÁL ÖNKÉNTES',
      EN: 'Festival Volunteer',
      RS: 'Volonter na festivalu',
    },
  },
  error: {
    HU: 'Sajnáljuk, váratlan hiba történt.',
    RS: 'Izvinjavamo se, došlo je do neočekivane greške.',
    EN: 'Sorry, an unexpected error has occurred.',
  },
  press: {
    HU: 'Sajtóakkreditáció 2024',
    RS: 'Akreditacije za medije 2024',
    links: {
      HU: 'https://docs.google.com/forms/d/e/1FAIpQLScBBDQQoYsBc-EpaA1RrvWsYwrQQMUK6xZRJdbkNG4DvYE30A/viewform',
      RS: 'https://docs.google.com/forms/d/e/1FAIpQLSdJ9BhMPR1XJrmM149g95YcfOwO20qokvi9rxwaEA4pVb8MiQ/viewform',
    },
  },
  else: {
    map: {
      HU: 'Térkép',
      RS: 'Mapa',
      EN: 'Map',
    },

  },
};
